import styled, { css } from 'styled-components';
import theme from '@legacy-vfuk/core-theme-ws10';
import { elevation } from '@legacy-vfuk/core-mixins';

const lineClamp = (linesQuantity: number) => `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${linesQuantity};
  -webkit-box-orient: vertical;
`;

export const ArticleWrapper = styled.div<{
  direction: 'ltr' | 'rtl';
  animated?: boolean;
  elevated?: boolean;
  media?: boolean;
}>`
  background: ${theme.color.monochrome1.default};
  height: 100%;
  text-align: start;
  overflow: hidden;
  border-radius: 6px;

  a {
    text-decoration: none !important;
    height: 100%;
    width: 100%;
  }

  ${props => props.elevated && elevation(true)}
  ${props =>
    props.animated &&
    css`
      @media only screen and (min-width: 1151px) {
        transition: all 0.2s ease-in-out;
        :hover {
          transform: scale(1.05);
        }
      }
    `};

  .summary {
    ${props => props.media ? lineClamp(3) : lineClamp(2)}
  }
`;

export const ContentLevelWrapper = styled.div`
  text-decoration: underline;
  text-underline-offset: 6px;
  text-decoration-color: ${theme.color.secondary5.default};
`;

export const InfoWrapper = styled.div`
  display: flex;
  gap: 20px;

  p {
    margin: 0;
  }

  @media only screen and (max-width: 1320px) {
    gap: 10px;
  }

  @media only screen and (max-width: 1150px) {
    gap: 20px;
  }

  @media only screen and (max-width: 325px) {
    gap: 10px;
  }
`;

export const IconWithTextWrapper = styled.div<{ useSmallerText?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  ${props =>
    props.useSmallerText
      ? css`
          p {
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            ${lineClamp(1)}

            @media only screen and (max-width: 1190px) {
              font-size: 15px;
              font-weight: 400;
              line-height: 10px;
            }

            @media only screen and (max-width: 1150px) {
              font-size: 16px;
              font-weight: 400;
              line-height: 20px;
            }
          }
        `
      : css`
          p {
            font-size: 18px;
            line-height: 30px;
            letter-spacing: 0.1px;
            ${lineClamp(1)}

            @media only screen and (max-width: 1320px) {
              font-size: 16px;
              font-weight: 400;
              line-height: 20px;
            }
          }
        `};
`;

export const SaveIconWrapper = styled.div`
  position: absolute;
  inset-inline-end: 10px;
  top: 10px;
  z-index: 1;

  path {
    fill: ${theme.color.monochrome1.default};
  }
`;

export const ContentTypeIconWrapper = styled.div`
  position: absolute;
  bottom: 10px;
  z-index: 1;
  inset-inline-start: 10px;
  padding-inline-end: 16px;
`;

export const MediaContentTypeIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 50%;
  z-index: 1;
`;

export const MediaImageWrapper = styled.div`
  position: relative;
  height: 100%;
  & > [data-gatsby-image-wrapper] {
    width: 100%;
  }
`;

export const ImageWrapper = styled.div<{ isFeatured?: boolean }>`
  position: relative;
  height: 100%;
  & > [data-gatsby-image-wrapper] {
    width: 100%;

    ${props =>
    props.isFeatured
      ? css`
            height: 100%;
          `
      : css`
            height: 230px;
            @media only screen and (max-width: 794px) {
              height: 202px;
            }
          `}
  }
`;

export const TagPillWrapper = styled.div`
  position: absolute;
  inset-inline-start: 10px;
  top: 13px;

  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  z-index: 1;
  font-weight: bold;
`;

export const ImageOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(37, 40, 43, 0) 18.95%,
    rgba(37, 40, 43, 0.64) 81.05%
  );
`;
